import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Logo from "../components/Logo";
import { useAuth } from "../context/AuthContext";
import { apiError } from "../services/api";
import sideImg from "../assets/brand/product2.jpg";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ full_name: "", email: "", phone: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await register(form.email, form.password, form.full_name, form.phone);
      toast.success(`Bienvenue dans la Maison The Queen, ${user.full_name.split(" ")[0]} !`);
      navigate("/", { replace: true });
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || "Création de compte impossible");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white">
      <div className="flex items-center justify-center p-6 sm:p-12 bg-white order-2 lg:order-1">
        <div className="w-full max-w-md">
          <Logo height={36} />
          <h1 className="font-display text-[#111111] mt-10 text-4xl">Créer un compte</h1>
          <p className="text-sm text-[#666666] mt-2">Rejoignez The Queen pour un suivi sur-mesure de vos rituels.</p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            {error && <div className="text-sm rounded-xl p-3 bg-red-50 text-red-700 border border-red-200" data-testid="register-error">⚠ {error}</div>}
            <div>
              <label className="label-eyebrow text-[#666666] block mb-2" htmlFor="name">Nom complet</label>
              <input id="name" required value={form.full_name} onChange={set("full_name")} className="w-full bg-white border border-[#EAE8E4] rounded-xl px-4 text-sm outline-none focus:border-[#111111] transition-colors" style={{ height: 48 }} data-testid="register-name" />
            </div>
            <div>
              <label className="label-eyebrow text-[#666666] block mb-2" htmlFor="email">Email</label>
              <input id="email" type="email" required value={form.email} onChange={set("email")} className="w-full bg-white border border-[#EAE8E4] rounded-xl px-4 text-sm outline-none focus:border-[#111111] transition-colors" style={{ height: 48 }} data-testid="register-email" />
            </div>
            <div>
              <label className="label-eyebrow text-[#666666] block mb-2" htmlFor="phone">Téléphone</label>
              <input id="phone" value={form.phone} onChange={set("phone")} placeholder="05 / 06 / 07..." className="w-full bg-white border border-[#EAE8E4] rounded-xl px-4 text-sm outline-none focus:border-[#111111] transition-colors" style={{ height: 48 }} data-testid="register-phone" />
            </div>
            <div>
              <label className="label-eyebrow text-[#666666] block mb-2" htmlFor="password">Mot de passe (min 8 caractères)</label>
              <input id="password" type="password" required minLength={8} value={form.password} onChange={set("password")} className="w-full bg-white border border-[#EAE8E4] rounded-xl px-4 text-sm outline-none focus:border-[#111111] transition-colors" style={{ height: 48 }} data-testid="register-password" />
            </div>
            <button type="submit" disabled={loading} className="btn-queen-primary w-full h-12 uppercase tracking-wider text-xs mt-2" data-testid="register-submit">{loading ? "Création..." : "Rejoindre The Queen"}</button>
          </form>

          <p className="text-xs text-[#666666] mt-6 text-center">
            Déjà cliente ? <Link to="/login" className="text-[#111111] font-semibold underline underline-offset-4">Se connecter</Link>
          </p>
          <Link to="/" className="block text-center text-xs text-[#888888] mt-4 hover:text-[#111111]">← Retour à la collection</Link>
        </div>
      </div>

      <div className="hidden lg:block relative bg-[#F8F8F6] order-1 lg:order-2">
        <img src={sideImg} alt="The Queen Haute Formulation" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/30 backdrop-blur-[2px]" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <p className="font-display italic text-4xl leading-tight">
            « La pureté moléculaire au cœur de chaque flacon. »
          </p>
        </div>
      </div>
    </div>
  );
}
